import { render, staticRenderFns } from "./vote_conflict.vue?vue&type=template&id=798c508e&"
import script from "./vote_conflict.vue?vue&type=script&lang=js&"
export * from "./vote_conflict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports